import React from "react";
import { Grid, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ecricon from '../icons/ecr.png'
import { Link } from "react-router-dom";
// icons
import AddBoxIcon from "@material-ui/icons/AddBox";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";
import EnhancedEncryptionIcon from "@material-ui/icons/EnhancedEncryption";
export default function Home() {
  const classes = useStyles();
  window.document.title = "homepage";
  return (
    <div class={classes.homepage}>
      <h1 class={classes.heading}>
        Ticky Ticket
      </h1>
      <div class={classes.root}>
        <h1 class={classes.subHeading}>Welcome to Ticky Ticket</h1>
        <div class={classes.detail_container}>
          <p class={classes.detail}>
          Ticky Ticket is a platform for users to buy event tickets.  They can purchase tickets via Ethereum's native cryptocurrency Ether, they can also buy tickets using our native currency ECR, EventCryptos. 
          </p>
          <p class={classes.detail}>
          If users pay through our currency to buy tickets, the users will gain incentives. It is beneficial for both users and us as the users will gain incentives while we get to promote our token ECR through this website.
          </p>
        </div>

        <Grid container>
          {/* <Grid item xs={12} sm={6} md={4}>
            <Link style={{ textDecoration: "none" }} to="/upcomingevent">
              {" "}
              <Paper class={classes.paper}>
                <EventIcon style={{ fontSize: "4rem" }} />
                <br />
                Upcomming Events
              </Paper>
            </Link>
          </Grid> */}

          {/* <Grid item xs={12} sm={6} md={4}>
            <Link style={{ textDecoration: "none" }} to="/pastevent">
              <Paper class={classes.paper}>
                <EventAvailableIcon style={{ fontSize: "4rem" }} />
                <br />
                Past Events
              </Paper>
            </Link>
          </Grid> */}

          <Grid item xs={12} sm={6} md={4}>
            <Link style={{ textDecoration: "none" }} to="/bookEvent">
              <Paper class={classes.paper}>
                <AddBoxIcon style={{ fontSize: "4rem" }} />
                <br />
                Book Event
              </Paper>
            </Link>
          </Grid>

          {/* <Grid item xs={12} sm={6} md={4}>
            <Link style={{ textDecoration: "none" }} to="/dashboard">
              <Paper class={classes.paper}>
                <DashboardIcon style={{ fontSize: "4rem" }} />
                <br />
                Dashboard
              </Paper>
            </Link>
          </Grid> */}

          <Grid item xs={12} sm={6} md={4}>
            <Link style={{ textDecoration: "none" }} to="/swap">
              <Paper class={classes.paper}>
                <SwapHorizIcon style={{ fontSize: "4rem" }} />
                <br />
                Swap Token
              </Paper>
            </Link>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Link style={{ textDecoration: "none" }} to="/userticket">
              <Paper class={classes.paper}>
                <ConfirmationNumberIcon style={{ fontSize: "4rem" }} />
                <br />
                Your Ticket
              </Paper>
            </Link>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundPosition: "center",
    padding:'5%',
    borderRadius: "5px",
    height:'100vh'
  },
  homepage: {
    width: "80%",
    margin: "auto",
    marginTop: "24px",
  },
  heading: {
    color: "white",
    textAlign:'center',
    fontSize: "3rem",
    fontWeight: "900",
    margin: 0,
    padding: 0,
    textTransform:'uppercase',
    marginTop: "10%",
  },
  subHeading:{
    textTransform:'uppercase',
    textAlign:'center',
    padding:'10px 0px',
    marginBottom:'5%',
    boxShadow:'inset 3px 3px 5px #0005, inset -3px -3px 5px #fff3'
  },
  detail_container:{
    width:'100%',
    display:'flex',
    flexWrap:'wrap',
    justifyContent:'space-between'
  },
  detail: {
    width:'48%',
    color: "white",
    textAlign: "justify",
    fontSize:'1.4rem',
    borderBottom:'1px solid #3333',
    boxShadow:'3px 3px 5px #0004,-3px -3px 5px #fff3',
    padding:'10px',
    borderRadius:'5px',
    marginTop:'40px'
  },
  paper: {
    padding: theme.spacing(2),
    height: "120px",
    margin: "5%",
    marginTop:'10%',
    textAlign: "center",
    color: "white",
    border: "2px solid white",
    borderRadius: "10px",
    transition: ".4s",
    "&:hover": {
      transform: "scale(1.1)",
      transformOrigin: "center",
      border: "2px solid black",
      cursor: "pointer",
      color:'black',
      background:'#86c5fc'
    },
    "&:active":{
      transform: "scale(0.93)",
      
    },
  }
}));
